import { render, staticRenderFns } from "./CountryCommunities.vue?vue&type=template&id=8fba46ea&lang=pug&"
import script from "./CountryCommunities.vue?vue&type=script&lang=js&"
export * from "./CountryCommunities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports